import {Component, effect, inject, OnInit} from '@angular/core';
import {MatTab, MatTabGroup} from "@angular/material/tabs";
import {TranslateModule} from "@ngx-translate/core";
import {JobStatusItem} from "../../core/definitions/job-status-item";
import {LoginService} from "../../core/login.service";
import {UserData} from "../../core/definitions/user-data";
import {UserPrivilege} from "../../administration/admin-user/User";
import {JobStatusSubscriberService} from "../../core/jobstatussubcriber/job-status-subscriber.service";
import {JobStatusItemComponent} from "./job-status-item/job-status-item.component";
import { OperationService } from 'src/app/operations/operation.service';
import { OperationStep } from 'src/app/core/definitions/operation-step';

@Component({
    selector: 'app-job-status-v2',
    imports: [
        MatTabGroup,
        MatTab,
        TranslateModule,
        JobStatusItemComponent
    ],
    templateUrl: './job-status-v2.component.html',
    styleUrl: './job-status-v2.component.scss'
})
export class JobStatusV2Component implements OnInit {
  // Injections
  private readonly jobStatusService: JobStatusSubscriberService = inject(JobStatusSubscriberService);
  private readonly loginService: LoginService = inject(LoginService);
  private readonly operationService: OperationService = inject(OperationService);

  private cachedSteps = {};
  private currentUser: UserData = null;

  constructor() {
    effect(() => {
      if (this.jobStatusService.allJobs().length) {
        for (const job of this.jobStatusService.allJobs()) {
          this.getStepSetJobStatusItemRef(job);
        }
      }
    })
  }

  ngOnInit () {
    this.loginService.currentUser.subscribe(user => {
      this.currentUser = user;
    });
  }

  get allJobs(): JobStatusItem[] {
    return this.jobStatusService.allJobs();
  }

  get userJobs(): JobStatusItem[] {
    return this.jobStatusService.allJobs().filter(job => job.created_by_id.replace('USER-', '') === this.currentUser?.artifact_id.replace('USER-', ''));
  }

  get userIsAdmin(): boolean {
    return this.currentUser?.rights_level === UserPrivilege.ADMIN;
  }

  private getStepSetJobStatusItemRef(jobStatusItem: JobStatusItem) {
    if (jobStatusItem.status === 'step complete') {
      const cachedKey = jobStatusItem.queue_id;
      const cachedStep = this.cachedSteps[cachedKey];
      if (!cachedStep) {
        this.operationService.getNextOperationStepFromQueue(jobStatusItem.queue_id).then(step => {
          this.cachedSteps[cachedKey] = step;
          this.setJobStatusItemRef(step, jobStatusItem);
        });
      } else {
        this.setJobStatusItemRef(cachedStep, jobStatusItem);
      }
    }
  }

  private setJobStatusItemRef(step: OperationStep, jobStatusItem: JobStatusItem) {
    if (step && step.change_state) {
      [jobStatusItem.ref, jobStatusItem.refParams] = this.operationService.getStateParams(
        step.change_state[0], jobStatusItem);
    }
  }
}
